<script setup lang="ts">
import { setFormAsTable } from "@/excel/excelOperations";
import type { ExcelFunction } from "@/services/custom-functions/customFunction.types";
import { useApiStore } from "@/stores/api/useApiStore";
import { HaskoningCombobox } from "@haskoning/vue-component-library";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";

const apiStore = useApiStore();
const { registrableFunctions } = storeToRefs(apiStore);

const selectedFunction = ref<ExcelFunction>();

const draftFormGenerator = (func: ExcelFunction) =>
  func.parameters.map((param) => ({
    [param.name]: "",
  }));

watch(registrableFunctions, (newFunctions) => {
  if (selectedFunction.value && !newFunctions.includes(selectedFunction.value)) {
    selectedFunction.value = undefined;
  }
});

watch(selectedFunction, async (newFunction) => {
  if (newFunction) {
    const responseItem = draftFormGenerator(newFunction);
    await setFormAsTable(responseItem, newFunction);
  }
});
</script>

<template>
  <HaskoningCombobox
    v-model="selectedFunction"
    :items="registrableFunctions"
    item-title="name"
    item-value="url"
    label="Select API Function"
    color="primary"
    supporting-text="Choose a function to generate the form"
    :clearable="true"
    variant="filled"
  />
</template>
